module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"18\" viewBox=\"0 0 12 18\">\n  <polyline fill=\"none\" stroke=\"#FFF\" points=\"18.646 16.349 7 8.175 18.646 0\" transform=\"translate(-7 1)\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/NavHandle/backChevron.svg
// module id = 882
// module chunks = 114276838955818